import EditIcon from "@mui/icons-material/Edit";

import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";

import { MODELS_CONFIG, MODELS_PHRASE } from "./config";
import { editBrandModel } from "redux/actions/buildings/brands/brandsMetersActions";
import RegularButton from "components/CustomButtons/Button";

const style = {
  color: "#004F9F",
  fontSize: 20,
  marginRight: 10,
  cursor: "pointer"
};

export const columns = [
  {
    Header: () => <span>{MODELS_CONFIG.brand.label}</span>,
    accessor: MODELS_CONFIG.brand.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[MODELS_CONFIG.brand.key]
        ? row[MODELS_CONFIG.brand.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{MODELS_CONFIG.model.label}</span>,
    accessor: MODELS_CONFIG.model.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[MODELS_CONFIG.model.key]
        ? row[MODELS_CONFIG.model.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editBrandModel(original.id));
      };
      return (
        <ColumnContainer>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip={MODELS_PHRASE.modal.actions.edit}
            onClick={openEdit}
            size="sm"
          >
            <EditIcon style={style} />
          </RegularButton>
        </ColumnContainer>
      );
    },
  },
];
